"use client";

import { useEffect, useState } from "react";

import { isDatadogProvider } from "@stadium/services/error-reporting/provider";

/**
 * Framework route tracker for error monitoring (Next.js App Router).
 * Loads Datadog only in the browser after mount to avoid duplicate SDK bundles on the server.
 */
export function AppRouterTracker() {
  const [DatadogAppRouter, setDatadogAppRouter] = useState(null);

  useEffect(() => {
    if (!isDatadogProvider()) {
      return;
    }

    import("@datadog/browser-rum-nextjs").then((mod) => {
      setDatadogAppRouter(() => mod.DatadogAppRouter);
    });
  }, []);

  if (!DatadogAppRouter) {
    return null;
  }

  return <DatadogAppRouter />;
}
